import { SelectOptionValues } from "../../../models/SelectOptionKeyValuePair"

export class StandardOptions {
    public static IEEE2014: SelectOptionValues = { key: 2014, value: "IEEE 519-2014" }
    public static IEEE2022: SelectOptionValues = { key: 2022, value: "IEEE 519-2022" }
}